<template>
  <t-default-layout active-nav-id="banners">
    <div :class="componentClassName">
      <a-back-page text="一覧画面" page="Banners" :show="show" />
      <form ref="form" class="t-banners-detail__form" enctype="multipart/form-data" @submit.prevent="handleFormSubmit">
        <div class="t-banners-detail__fields">
          <m-section>
            <m-action-card
              :id="idName[1]"
              test-id-text="detail-banner"
              title="詳細設定"
              :document-id="id"
              header-border
              no-header-margin
              icon="clock"
            >
              <div class="t-banners-detail__fields">
                <div class="t-banners-detail__row">
                  <m-form-input id="t-banners-detail-importantFlag__form-input">
                    <a-text id="t-banners-detail-importantFlag__a-text">優先</a-text>
                    <a-switch
                      id="t-banners-detail-importantFlag"
                      v-model="bannerData.importantFlag"
                      data-testid="detail-banner-priority-display"
                      :disabled="true"
                    />
                  </m-form-input>
                </div>
                <o-transition-type-selector
                  v-if="updatedDataFlag"
                  v-model:transition-type="bannerData.transitionType"
                  v-model:transition-doc="bannerData.transitionDoc"
                  v-model:contents-url="bannerData.contentsURL"
                  disabled="true"
                />
                <div v-if="bannerData.transitionType === 'url'" class="t-banners-detail__row">
                  <m-form-input id="t-banners-detail-info-dAccountLoginFlag__form-input">
                    <a-text id="t-banners-detail-info-dAccountLoginFlag__a-text">ビジネスｄアカウントログイン</a-text>
                    <a-switch
                      id="t-banners-detail-dAccountLoginFlag"
                      v-model="bannerData.dAccountLoginFlag"
                      :disabled="true"
                    />
                  </m-form-input>
                </div>
                <div v-if="bannerData.transitionType === 'url'" class="t-banners-detail__row">
                  <m-form-input id="t-banners-detail-info-webviewFlag__form-input">
                    <a-text id="t-banners-detail-info-webviewFlag__a-text">Webビュー</a-text>
                    <a-switch id="t-banners-detail-webviewFlag" v-model="bannerData.webviewFlag" :disabled="true" />
                  </m-form-input>
                </div>
                <div v-if="bannerData.transitionType === 'url'" class="t-banners-detail__row">
                  <m-form-input id="t-banners-detail-info-reloclubFlag__form-input">
                    <a-text id="t-banners-detail-info-reloclubFlag__a-text">リロクラブ連携</a-text>
                    <a-switch id="t-banners-detail-reloclubFlag" v-model="bannerData.reloclubFlag" :disabled="true" />
                  </m-form-input>
                </div>
                <div id="t-banners-add-info-showPopupFlag__form-input" class="t-banners-detail__fields">
                  <m-form-input>
                    <a-text id="t-banners-detail-info-showPopupFlag__a-text">ポップアップ表示</a-text>
                    <a-switch id="t-banners-detail-showPopupFlag" v-model="bannerData.showPopupFlag" :disabled="true" />
                  </m-form-input>
                  <div v-if="bannerData.showPopupFlag" class="t-banners-detail__fields__upload-file">
                    <a-text v-if="bannerData.showPopupFlag" id="t-banners-detail__fields__upload-file__a-text_1"
                      >ポップアップ用画像（340*222px推奨）</a-text
                    >
                    <m-form-input>
                      <a-upload-field
                        id="t-banners-detail__fields__upload-file"
                        v-model="bannerData.popupImageFile.file"
                        test-id-text="detail-popup-banner-image"
                        name="popupImageFile"
                        class="t-banners-detail-uploading-file__form-upload"
                        label="ファイルをドラッグ＆ドロップするかパソコンからファイルを貼り付けしてください。"
                        :disabled="true"
                      />
                    </m-form-input>
                  </div>
                </div>
                <div id="t-banners-detail-uploading-file" class="t-banners-detail__row">
                  <div class="t-banners-detail__col-1">
                    <div class="t-banners-detail__fields">
                      <a-text v-if="bannerData.showPopupFlag" id="t-banners-detail__fields__upload-file__a-text_2"
                        >バナー用画像（340*89px推奨）</a-text
                      >
                      <m-form-input>
                        <a-upload-field
                          id="t-banners-detail-upload-image"
                          v-model="bannerData.imageFile.file"
                          test-id-text="detail-banner-image"
                          name="imageFile"
                          class="t-banners-detail-uploading-file__form-upload"
                          label="ファイルをドラッグ＆ドロップするかパソコンからファイルを貼り付けしてください。"
                          :disabled="true"
                        />
                      </m-form-input>
                    </div>
                  </div>
                  <div class="t-banners-detail__col-2">
                    <div class="t-banners-detail__fields">
                      <m-form-input>
                        <a-apply-text-field
                          id="title"
                          v-model="bannerData.title"
                          data-testid="detail-banner-title-display"
                          type="text"
                          maxlength="17"
                          maxlength-id="detail-banner-title-maxlength"
                          placeholder="タイトル入力"
                          :disabled="true"
                        />
                      </m-form-input>
                      <m-form-input>
                        <a-apply-text-field
                          v-model="bannerData.text"
                          data-testid="detail-banner-content-display"
                          class="t-banners-detail__content-input"
                          type="textarea"
                          rows="7"
                          maxlength="42"
                          maxlength-id="detail-banner-content-maxlength"
                          placeholder="テキスト入力"
                          :disabled="true"
                        />
                      </m-form-input>
                    </div>
                  </div>
                </div>
              </div>
            </m-action-card>
          </m-section>
          <m-section>
            <m-action-card :id="idName[3]" title="公開設定" header-border no-header-margin icon="calendar-setting">
              <div class="t-banners-detail__fields">
                <div id="t-banners-detail-cast-start-date-day__row" class="t-banners-detail__row">
                  <a-text id="t-banners-detail-cast-start-date__a-text">公開日</a-text>　
                  <m-form-input id="t-banners-detail-cast-start-date-day__form-input">
                    <a-calendar-field
                      id="cast-start-date-day"
                      v-model="bannerData.castStartDate"
                      test-id-text="detail-banner-publish-start"
                      :min-date="minDate"
                      mode="dateTime"
                      :disabled="true"
                    />
                  </m-form-input>
                </div>
                <div class="t-banners-detail__row">
                  <a-text id="t-banners-detail-cast-end-date__a-text">公開終了日</a-text>　
                  <m-form-input id="t-banners-detail-cast-end-date-day__form-input">
                    <a-calendar-field
                      id="cast-end-date-day"
                      v-model="bannerData.castEndDate"
                      test-id-text="detail-banner-publish-end"
                      :min-date="minDate"
                      mode="dateTime"
                      :disabled="true"
                      @change="handleChange"
                    />
                  </m-form-input>
                </div>
              </div>
            </m-action-card>
          </m-section>
          <m-section>
            <m-action-card :id="idName[4]" title="承認フロー" header-border no-header-margin icon="user-setting">
              <div class="t-banners-detail__fields__pushtype">
                <m-form-input id="t-banners-detail__fields__pushtype">
                  <a-select-field
                    id="t-banners-detail__fields__pushtype__a-select-field"
                    v-model="bannerData.checkStatus"
                    data-testid="detail-banner-check-status-select"
                    :options="checkStatusOptions"
                    disabled="true"
                  />
                </m-form-input>
              </div>
              <!-- 情報を表示するために m-data-table を追加します 承認フロー -->
              <m-data-table
                :empty-text="dataTableEmp"
                :fit="true"
                :data="bannerData.checkHistories"
                id-text="banners-check-histories-info-display"
              >
                <a-data-table-column
                  prop="publishedDocumentId"
                  :min-width="120"
                  :label="'公開ドキュメントID：<br>' + docId"
                  align="center"
                >
                  <template #default="scope">
                    <a-text size="medium" :center="true">公開{{ scope.index + 1 }}回目</a-text>
                  </template>
                </a-data-table-column>
                <a-data-table-column prop="draft" :min-width="100" label="下書き" align="center">
                  <template #default="scope">
                    <a-text size="medium" :center="true">{{ scope.row.draft.userName }}</a-text>
                    <a-text size="small" :center="true">{{ scope.row.draft.updateDate }}</a-text>
                  </template>
                </a-data-table-column>
                <a-data-table-column prop="checked" :min-width="100" label="チェック済み" align="center">
                  <template #default="scope">
                    <a-text size="medium" :center="true">{{ scope.row.checked.userName }}</a-text>
                    <a-text size="small" :center="true">{{ scope.row.checked.updateDate }}</a-text>
                  </template>
                </a-data-table-column>
                <a-data-table-column prop="approved" :min-width="100" label="承認済み" align="center">
                  <template #default="scope">
                    <a-text size="medium" :center="true">{{ scope.row.approved.userName }}</a-text>
                    <a-text size="small" :center="true">{{ scope.row.approved.updateDate }}</a-text>
                  </template>
                </a-data-table-column>
              </m-data-table>
            </m-action-card>
          </m-section>
        </div>
        <div v-if="bannerData.showPopupFlag" id="t-banners-test-buttons">
          <o-test-push :id="id" type="banners" />
        </div>
        <div id="t-banners-detail-buttons">
          <div v-show="!isPublished" class="t-banners-detail-buttons__button">
            <m-form-action-buttons>
              <a-button
                id="t-banners-detail-detail-saveBtn"
                data-testid="detail-banner-edit-button"
                variant="block"
                color="primary"
                :disabled="isEnded || disableButton"
                @click="handleNavigateEdit"
                >編集</a-button
              >
            </m-form-action-buttons>
          </div>
          <div v-show="isPublished" class="t-banners-detail-buttons__button">
            <m-form-action-buttons>
              <a-button
                id="t-banners-detail-edit-return-unpublished-btn"
                data-testid="detail-banner-edit-return-unpublished-button"
                variant="block"
                color="primary"
                :disabled="disableButton"
                @click.stop="handleEditReturnUnpublished"
                >未公開に戻す</a-button
              >
            </m-form-action-buttons>
          </div>
          <div v-show="isPublished" class="t-banners-detail-buttons__button">
            <m-form-action-buttons>
              <a-button
                id="t-banners-detail-edit-keep-published-btn"
                data-testid="detail-banner-edit-keep-published-button"
                variant="block"
                color="primary"
                :disabled="disabledButton || disableButton"
                @click.stop="handleEditKeepPublished"
                >公開のまま編集</a-button
              >
            </m-form-action-buttons>
          </div>
          <div class="t-banners-detail-buttons__button">
            <m-form-action-buttons>
              <a-button
                id="t-banners-detail-detail-deleteBtn"
                data-testid="detail-banner-delete-button"
                variant="block"
                color="primary"
                :disabled="disableButton"
                @click.stop="handleConfirmDelete"
                >削除</a-button
              >
            </m-form-action-buttons>
          </div>
        </div>
      </form>
    </div>

    <!-- Info, Erro Modal -->
    <teleport to="body">
      <o-modal
        id="bannersCreate_resultModal"
        v-model:visible="resultModalVisible"
        class="o-modal--confirmation"
        footer-variant="confirmation"
        width="442px"
        :footer-shadow="false"
        :close-on-click-modal="false"
        :close-on-press-escape="false"
        :show-close="false"
      >
        <template #title>{{ resultModalTitle }}</template>
        <a-text>
          <!-- eslint-disable -->
          <span id="banners-bannersCreate_resultModal_body" v-html="resultModalContent" />
          <!-- eslint-enable -->
        </a-text>
        <template #footer>
          <a-button
            id="t-banners-remove-modal-close-button"
            data-testid="detail-banners-cancel-button"
            variant="outlined"
            color="primary"
            label="いいえ"
            size="small"
            @click="handleCloseModal"
          />
          <a-button
            id="t-banners-delete-button"
            data-testid="detail-banners-confirm-button"
            variant="block"
            color="primary"
            label="はい"
            size="small"
            @click="handleDelete"
          />
        </template>
      </o-modal>
    </teleport>
  </t-default-layout>
</template>

<script>
import { mapModifiers } from '@/libs/component';
import AButton from '@/components/atoms/button';
import ASwitch from '@/components/atoms/switch';
import AUploadField from '@/components/atoms/upload-field';
import AText from '@/components/atoms/text';
import ABackPage from '@/components/atoms/back-page';
import AApplyTextField from '@/components/atoms/apply-text-field';
import MSection from '@/components/molecules/section';
import MActionCard from '@/components/molecules/action-card';
import MFormActionButtons from '@/components/molecules/form-action-buttons';
import OTransitionTypeSelector from '@/components/organisms/transition-type-selector';
import TDefaultLayout from '@/components/templates/default-layout';
import { customRequest } from '@/common/customRequest.js';
import { messageContent } from '@/common/messageContent.js';
import { customValidate } from '@/common/customValidate.js';
import ACalendarField from '@/components/atoms/calendar-field';
import { utils } from '@/common/utils.js';

export default {
  name: 't-banners-detail',
  components: {
    TDefaultLayout,
    MSection,
    MActionCard,
    AText,
    AButton,
    ABackPage,
    MFormActionButtons,
    ASwitch,
    AUploadField,
    ACalendarField,
    AApplyTextField,
    OTransitionTypeSelector,
  },
  mixins: [customRequest, customValidate, messageContent],
  props: {
    class: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      id: this.$route.query.id,
      show: this.$route.query.show ?? '1',
      idName: [],
      disableButton: false,
      minDate: utils.currentDateTime(),
      resultModalTitle: '',
      resultModalContent: '',
      resultModalVisible: false,
      disabledButton: null,
      isPublished: false, //公開中かどうかのフラグ
      docId: (() => {
        const id = this.$route.query.id;
        if (id.includes('_')) {
          const lastIndex = id.lastIndexOf('_');
          return id.slice(0, lastIndex);
        }
        return id;
      })(),

      //バナーデータ
      bannerData: {
        title: '', //バナータイトル
        text: '', //バナーテキスト
        imageURL: '', //画像の公開URL
        imageFile: {
          file: null,
          filename: null,
          binary: null,
          size: null,
        },
        importantFlag: false, //優先フラグ
        dAccountLoginFlag: false, //ビジネスｄアカウントログインフラグ
        webviewFlag: false, //Webビューフラグ
        reloclubFlag: false, //リロクラブ連携フラグ
        showPopupFlag: false, //ポップアップ表示フラグ
        castStartDate: '', //公開開始日
        castEndDate: '', //公開終了日
        draftFlag: false, //下書き
        checkStatus: '', //チェックステータス
        contentsURL: '', //URL
        popupImageURL: '',
        popupImageFile: {
          file: null,
          filename: null,
          binary: null,
          size: null,
        },
        checkHistories: [
          {
            draft: {
              userName: '',
              updateDate: '',
            },
            checked: {
              userName: '',
              updateDate: '',
            },
            approved: {
              userName: '',
              updateDate: '',
            },
          },
        ],
        transitionType: 'url',
        transitionDoc: '',
      },
      checkStatusOptions: [
        { value: 'draft', label: '下書き' },
        { value: 'checked', label: 'チェック済み' },
        { value: 'approved', label: '承認済み' },
      ],
      isEnded: false,
      nowDate: '',
      updatedDataFlag: false,
    };
  },
  computed: {
    componentClassName() {
      const baseClassName = mapModifiers('t-banners-detail');
      return `${baseClassName} ${this.class}`.trim();
    },
  },
  created() {
    this.handleGetBannerInfo(() => {
      const userRole = this.$store.state.user.authInfo;
      const checkStatus = this.bannerData.checkStatus;
      if (userRole === 'writer' && checkStatus !== 'draft') {
        this.disableButton = true;
      }
    });
    for (let i = 1; i <= 4; i++) {
      this.idName[i] = 'h1-banners-detail-' + i;
    }
  },
  mounted() {},
  methods: {
    handleGetBannerInfo(callback) {
      const id = this.$route.query.id || this.id;
      this.nowDate = utils.currentDateTime();
      if (id) {
        this.postRequest('/banners/get', { id })
          .then(e => {
            if (e.status === 'success' && e.data) {
              const data = e.data;
              this.bannerData.title = data?.title || '';
              this.bannerData.text = data?.text || '';
              this.bannerData.imageURL = data?.imageURL || '';
              (this.bannerData.imageFile = {
                file: e.data.imageURL ? e.data.imageURL : null,
              }),
                (this.bannerData.importantFlag = data?.importantFlag || false);
              this.bannerData.dAccountLoginFlag = data?.dAccountLoginFlag || false;
              this.bannerData.popupImageURL = data?.popupImageURL || '';
              (this.bannerData.popupImageFile = {
                file: e.data.popupImageURL ? e.data.popupImageURL : null,
              }),
                (this.bannerData.webviewFlag = data?.webviewFlag || false);
              this.bannerData.reloclubFlag = data?.reloclubFlag || false;
              this.bannerData.showPopupFlag = data?.showPopupFlag || false;
              this.bannerData.castStartDate = data?.castStartDate || '';
              this.bannerData.castEndDate = data?.castEndDate || '';
              this.bannerData.draftFlag = data?.draftFlag || false;
              this.bannerData.contentsURL = decodeURI(data?.contentsURL) || '';
              this.bannerData.checkStatus = data?.checkStatus || '';
              this.bannerData.checkHistories = data?.checkHistories || [];
              this.bannerData.transitionType = data?.transitionType || 'url';
              this.bannerData.transitionDoc = data?.transitionDoc || '';
              // 下書きとチェク済み中ではなく、公開終了日時を過ぎている場合、isEndedフラグをtrueにする
              if (this.bannerData.checkStatus === 'approved') {
                if (this.bannerData.castEndDate && this.bannerData.castEndDate < this.nowDate) {
                  this.isEnded = true;
                }
              }
              const nowDate = utils.currentDateTime();
              // 公開中の投稿か確認
              if (
                data &&
                data.checkStatus === 'approved' &&
                data.castStartDate &&
                data.castEndDate &&
                data.castStartDate <= nowDate &&
                nowDate <= data.castEndDate
              ) {
                this.isPublished = true;
              }
            } else {
              this.showErrorModal(messageContent.requireTry('バナー取得'));
            }
            if (typeof callback === 'function') {
              callback();
            }
            this.updatedDataFlag = true;
          })
          .catch(error => {
            console.error(error);
            this.showErrorModal(messageContent.requireTry('バナー取得'));
          });
      }
    },
    async handleEditReturnUnpublished() {
      const data = {
        id: this.$route.query.id,
      };
      await this.postRequest('/banners/edit-return-unpublished', data).then(res => {
        if (res.status === 'success') {
          this.$router.push({ name: 'Banners' });
        } else {
          if (res.message) {
            this.showErrorModal(res.message);
          } else {
            this.showErrorModal(messageContent.requireTry('バナー更新'));
          }
        }
      });
    },
    async handleEditKeepPublished() {
      const data = {
        id: this.$route.query.id,
      };
      this.disabledButton = 'disabled';
      await this.postRequest('/banners/edit-keep-published', data).then(res => {
        if (res.status === 'success') {
          this.$router.push({ name: 'Banners' });
        } else {
          if (res.message) {
            this.showErrorModal(res.message);
          } else {
            this.showErrorModal(messageContent.requireTry('バナー更新'));
          }
        }
        this.disabledButton = null;
      });
    },
    handleNavigateEdit() {
      const id = this.$route.query.id;
      if (id) {
        this.$router.push({ name: 'BannersEdit', query: { id: id, source: 'detail', show: this.show } });
      }
    },
    handleConfirmDelete() {
      this.resultModalVisible = true;
      this.resultModalTitle = 'Info';
      this.resultModalContent = messageContent.confirmDelete(this.bannerData.title);
    },
    handleDelete() {
      this.handleCloseModal();
      const data = {
        execUserID: this.$store.state.user.userID,
        documentID: this.$route.query.id,
      };
      this.postRequest('/banners/delete', data).then(() => {
        this.$router.push({ name: 'Banners', query: { show: this.show } });
      });
    },
    handleCancelClick() {
      this.$router.push({ name: 'Banners', query: { show: this.show } });
    },
    handleCloseModal() {
      this.resultModalVisible = false;
      this.resultModalTitle = '';
      this.resultModalContent = '';
    },
    showErrorModal(message) {
      this.resultModalVisible = true;
      this.resultModalTitle = messageContent.errorModalTitle;
      this.resultModalContent = message;
    },
    showInfoModal(message) {
      this.resultModalVisible = true;
      this.resultModalTitle = messageContent.infoModalTitle;
      this.resultModalContent = message;
    },
  },
};
</script>
